import { PLAN_TIERS } from './userProperties';

const SLUG_PREFIXES = new Set(['line-chart', 'candle-line-chart', 'bar-chart']);

const EXACT_PATHS = {
  'options-table': PLAN_TIERS.FREE,
  'payoff-chart': PLAN_TIERS.FREE,
  'greek-chart': PLAN_TIERS.FREE,
  'position-table': PLAN_TIERS.FREE,
  'fii-data': PLAN_TIERS.FREE,
  'index-table': PLAN_TIERS.FREE,
  'hv-stock-chart': PLAN_TIERS.FREE,
  bookmarks: PLAN_TIERS.PROFESSIONAL,
  'market-profile': PLAN_TIERS.PROFESSIONAL,
  'global-bookmarks': PLAN_TIERS.ELITE,
  orderflow: PLAN_TIERS.ELITE,
  'orderflow-preview': PLAN_TIERS.ELITE,
  'candle-line-chart': PLAN_TIERS.ELITE,
};

const SLUG_TIERS = [
  { test: /ntm_oi_change|ntm_oi/i, tier: PLAN_TIERS.PROFESSIONAL },
  { test: /oi_change/i, tier: PLAN_TIERS.FREE },
  { test: /ntm_volx/i, tier: PLAN_TIERS.PROFESSIONAL },
  { test: /vol_charts/i, tier: PLAN_TIERS.FREE },
  { test: /strike_spectrum|spectrum/i, tier: PLAN_TIERS.PROFESSIONAL },
  { test: /mviz/i, tier: PLAN_TIERS.PROFESSIONAL },
  { test: /snakes/i, tier: PLAN_TIERS.PROFESSIONAL },
  { test: /gamma_density/i, tier: PLAN_TIERS.ELITE },
  { test: /gamma_curves/i, tier: PLAN_TIERS.ELITE },
  { test: /strike_wcash/i, tier: PLAN_TIERS.FREE },
  { test: /strike_oi/i, tier: PLAN_TIERS.FREE },
  { test: /strike_iv/i, tier: PLAN_TIERS.FREE },
];

function pathnameFrom(routeOrPath) {
  if (!routeOrPath) {
    return '/';
  }
  try {
    const pathname = new URL(routeOrPath, 'https://charts.vtrender.com').pathname;
    return pathname.replace(/\/+$/, '') || '/';
  } catch {
    return routeOrPath.replace(/\/+$/, '') || '/';
  }
}

function slugTier(slug) {
  for (const rule of SLUG_TIERS) {
    if (rule.test.test(slug)) {
      return rule.tier;
    }
  }
  return undefined;
}

export function getToolEntitlement(routeOrPath) {
  const path = pathnameFrom(routeOrPath);
  const parts = path.split('/').filter(Boolean);

  if (parts.length === 0) {
    return undefined;
  }

  const [prefix, slug] = parts;

  if (prefix.endsWith('_iv-range') || prefix.endsWith('-iv-range')) {
    return PLAN_TIERS.ELITE;
  }

  if (SLUG_PREFIXES.has(prefix) && slug) {
    return slugTier(slug);
  }

  if (EXACT_PATHS[prefix] && !slug) {
    return EXACT_PATHS[prefix];
  }

  if (prefix === 'hv-stock-chart') {
    return PLAN_TIERS.FREE;
  }

  return undefined;
}
